module.exports = __webpack_public_path__ + "static/media/sketch.7b378f28.svg";